module.exports = __webpack_public_path__ + "static/img/coupon-in-hand.d00df8fe.png";